/* EoxBulletinViewFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");
const _ = require("lodash");

class PagingCompEoxFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedComponentEoxesFeed(this._filter, this._entityFields, this._sort, { skip: 0, limit: this._pageSize * 2 });
    }

    _feedShutDown() {
        if (_.isUndefined(this._EntityDef)) {
            return Promise.resolve();
        } else {
            return this._EntityDef.stopRelatedComponentEoxesFeed();
        }
    }
}

module.exports = PagingCompEoxFeed;
